module.exports = {"540626100":"亚拉镇","540626101":"荣布镇","540626201":"若达乡","540626202":"加勤乡","540626203":"赤多乡","540626205":"西昌乡","540626206":"江达乡","540626208":"热瓦乡","540626209":"嘎美乡","540626210":"嘎木乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540626.json
// module id = 2877
// module chunks = 0